import { activityHistoryCollectionsSlice } from "../../slice";

export const { addBusyHistoryItem, removeBusyHistoryItem } =
  activityHistoryCollectionsSlice.actions;
